import { Stack } from "@mui/material";
import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import MenuItem from "@mui/material/MenuItem";
import OutlinedInput from "@mui/material/OutlinedInput";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Select from "@mui/material/Select";
import Typography from "@mui/material/Typography";
import dayjs from "dayjs";
import { useEffect, useState } from "react";

const inputStyle = {
  fontSize: "14px",
  my: "8px",
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#BDBDBD",
  },
  "& .MuiInputBase-input": { padding: "8px 14px" },
  "& input::placeholder": {
    fontSize: "14px",
    fontWeight: 500,
    color: "#CCD1D9",
    opacity: 1,
  },
  backgroundColor: "primary.light",
  width: "100%",
};

const colorRequired = {
  color: "#ED5565",
  fontSize: "14px",
  fontWeight: "500",
};

type GenerateFieldChildType = {
  field: any;
  answer: any;
  labelParent: string;
  handleChildChangeValue: (name: string, value: any) => void;
  handleChildDFChangeValue: (name: string, value: any) => void;
  handleChildMultiChangeValue: (name: string, value: any) => void;
  handleChildMultiDFChangeValue: (name: string, value: any) => void;
};

const GenerateFieldChild: React.FC<GenerateFieldChildType> = (props) => {
  const field = props.field;
  const [disable, setDisable] = useState(true);

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>, name: string) => {
    const { value } = event.target;
    props.handleChildChangeValue(name, value);
  };

  const handleSelectChange = (event: any, name: string) => {
    const { value } = event.target;
    props.handleChildChangeValue(name, value);
  };

  const handleInputChange = (event: any) => {
    props.handleChildChangeValue(event.target.name, event.target.value);
  };

  const handleCheckboxChange = (event: any, name: string) => {
    const { value, checked } = event.target;
    let tempAnswer: any = [];
    if (!props.answer?.children_answers) {
      tempAnswer = [value];
      console.log(tempAnswer);
    } else {
      if (checked) {
        tempAnswer = [...props.answer?.children_answers[field.field_id]?.value, ...[value]];
      } else {
        tempAnswer = props.answer?.children_answers[field.field_id]?.value.filter((val: any) => val !== value);
      }
    }
    props.handleChildMultiChangeValue(name, tempAnswer);
  };

  const handleCheckboxDFChange = (event: any, name: string) => {
    const { value, checked } = event.target;
    let tempAnswer: any = [];
    if (!props.answer?.children_answers[field.field_id]?.dependent_answers) {
      tempAnswer = [value];
      console.log(tempAnswer);
    } else {
      if (checked) {
        tempAnswer = [...props.answer?.children_answers[field.field_id]?.dependent_answers, ...[value]];
      } else {
        tempAnswer = props.answer?.children_answers[field.field_id]?.dependent_answers.filter((val: any) => val !== value);
      }
    }
    props.handleChildMultiDFChangeValue(name, tempAnswer);
  };

  const handleSelectDFChange = (event: any, name: string) => {
    const { value } = event.target;
    props.handleChildDFChangeValue(name, value);
  };

  const handleSelectDFYearChange = (event: any, name: string) => {
    const { value } = event.target;
    let result = `${value}-${dayjs().month() + 1}`;
    if (props.answer && props.answer?.children_answers && props.answer?.children_answers[field.field_id] && props.answer?.children_answers[field.field_id]?.dependent_answers) {
      const depAns = props.answer?.children_answers[field.field_id]?.dependent_answers[0].split("-");
      result = `${value}-${depAns[1] ? depAns[1] : dayjs().month() + 1}`;
    }

    props.handleChildDFChangeValue(name, result);
  };

  const handleSelectDFMonthChange = (event: any, name: string) => {
    const { value } = event.target;
    console.log(value);
    let result = `${dayjs().year()}-${value}`;
    if (props.answer && props.answer?.children_answers && props.answer?.children_answers[field.field_id] && props.answer?.children_answers[field.field_id]?.dependent_answers) {
      const depAns = props.answer?.children_answers[field.field_id]?.dependent_answers[0].split("-");
      result = `${depAns[0] ? depAns[0] : dayjs().year()}-${value}`;
    }

    props.handleChildDFChangeValue(name, result);
  };

  const handleInputForCheckboxChange = (event: any) => {
    const { name, value } = event.target;
    let tempAnswer = {};
    if (!props.answer?.children_answers[field.field_id].dependent_answers) {
      tempAnswer = [
        {
          [name]: value,
        },
      ];
    } else {
      tempAnswer = [
        {
          ...props.answer?.children_answers[field.field_id].dependent_answers[0],
          [name]: value,
        },
      ];
    }

    props.handleChildMultiDFChangeValue(field.field_id, tempAnswer);
  };

  useEffect(() => {
    setDisable(true);
    if (props.answer) {
      if (props.answer["value"][0] === props.labelParent) {
        setDisable(false);
      }
    }
  }, [props.answer, props.labelParent]);

  switch (field.type) {
    case "radio":
      return (
        <Box my={"5px"} ml={"20px"}>
          <Typography fontWeight={700}>
            {field.label}
            {field.required && (
              <Typography component="label" {...colorRequired}>
                *
              </Typography>
            )}
          </Typography>
          <RadioGroup
            // row
            aria-labelledby="demo-controlled-radio-buttons-group"
            name={field.field_id}
            value={props.answer?.children_answers && props.answer?.children_answers[field.field_id] ? props.answer?.children_answers[field.field_id]?.value : ""}
            onChange={(e) => handleRadioChange(e, field.field_id)}
          >
            {field.options.map((option: any, idx: number) => {
              return <FormControlLabel key={idx} value={option} control={<Radio disabled={disable} />} label={option} />;
            })}
          </RadioGroup>
        </Box>
      );
    case "select":
      return (
        <Stack direction="row" spacing={"8px"} justifyContent={"flex-start"} alignItems={"center"} width={"100%"} my={"8px"} ml={"20px"}>
          {field.label && (
            <Typography width={"100px"}>
              {field.label}
              {field.required && (
                <Typography component="label" {...colorRequired}>
                  *
                </Typography>
              )}
            </Typography>
          )}

          <Select
            value={props.answer?.children_answers && props.answer?.children_answers[field.field_id] ? props.answer?.children_answers[field.field_id]?.value : ""}
            disabled={disable}
            onChange={(e) => handleSelectChange(e, field.field_id)}
            sx={{
              backgroundColor: "primary.light",
              width: "100%",
              "& .MuiInputBase-input.MuiOutlinedInput-input": {
                p: "6px 14px",
              },
            }}
          >
            {field.options.map((option: any, idx: number) => {
              return (
                <MenuItem value={option} key={idx}>
                  {option}
                </MenuItem>
              );
            })}
          </Select>
        </Stack>
      );
    case "text":
      return (
        <>
          <Stack direction="row" spacing={"8px"} justifyContent={"flex-start"} alignItems={"center"} width={"100%"} my={"8px"} ml={"20px"}>
            <Typography width={"100px"}>
              {field.label || "-"}
              {field.required && (
                <Typography component="label" {...colorRequired}>
                  *
                </Typography>
              )}
            </Typography>
            <OutlinedInput
              placeholder={field.help_text}
              sx={inputStyle}
              inputProps={{
                sx: {
                  backgroundColor: "primary.light",
                },
              }}
              disabled={disable}
              name={field.field_id}
              value={props.answer?.children_answers && props.answer?.children_answers[field.field_id] ? props.answer?.children_answers[field.field_id]?.value : ""}
              onChange={(event) => handleInputChange(event)}
            />
          </Stack>
          {field.dependent_fields &&
            Array.isArray(field.dependent_fields) &&
            field.dependent_fields.map((df: any, index: number) => {
              if (df.type === "select") {
                return (
                  <Stack key={index} direction="row" spacing={"8px"} justifyContent={"flex-start"} alignItems={"center"} width={"100%"} my={"8px"} ml={"20px"}>
                    <Typography width={"90px"}>{df.label}</Typography>
                    <Select
                      value={props.answer?.children_answers && props.answer?.children_answers[field.field_id] ? props.answer?.children_answers[field.field_id]?.dependent_answers : ""}
                      onChange={(e) => handleSelectDFChange(e, field.field_id)}
                      sx={{
                        backgroundColor: "primary.light",
                        width: "150px",
                        "& .MuiInputBase-input.MuiOutlinedInput-input": {
                          p: "6px 14px",
                        },
                      }}
                      disabled={disable}
                    >
                      {df.options.map((option: any, idx: number) => {
                        return (
                          <MenuItem value={option} key={idx}>
                            {option}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </Stack>
                );
              }
              if (df.type === "year_month") {
                return (
                  <Stack key={index} direction="row" spacing={"8px"} justifyContent={"flex-start"} alignItems={"center"} width={"100%"} my={"8px"} ml={"20px"}>
                    <Typography width={"90px"}>{df.label}</Typography>
                    <Select
                      value={
                        props.answer && props.answer?.children_answers && props.answer?.children_answers[field.field_id] && props.answer?.children_answers[field.field_id]?.dependent_answers
                          ? props.answer?.children_answers[field.field_id]?.dependent_answers[0].split("-")[0]
                          : ""
                      }
                      name="year"
                      onChange={(e) => handleSelectDFYearChange(e, field.field_id)}
                      sx={{
                        backgroundColor: "primary.light",
                        width: "150px",
                        "& .MuiInputBase-input.MuiOutlinedInput-input": {
                          p: "6px 14px",
                        },
                      }}
                      disabled={disable}
                    >
                      {Array.from({ length: 150 }).map((option: any, idx: number) => {
                        return (
                          <MenuItem value={idx + 1950} key={idx}>
                            {idx + 1950}
                          </MenuItem>
                        );
                      })}
                    </Select>
                    <Typography>年</Typography>
                    <Select
                      value={
                        props.answer && props.answer?.children_answers && props.answer?.children_answers[field.field_id] && props.answer?.children_answers[field.field_id]?.dependent_answers
                          ? props.answer?.children_answers[field.field_id]?.dependent_answers[0].split("-")[1]
                          : ""
                      }
                      name="month"
                      onChange={(e) => handleSelectDFMonthChange(e, field.field_id)}
                      sx={{
                        backgroundColor: "primary.light",
                        width: "150px",
                        "& .MuiInputBase-input.MuiOutlinedInput-input": {
                          p: "6px 14px",
                        },
                      }}
                      disabled={disable}
                    >
                      {Array.from({ length: 12 }).map((option: any, idx: number) => {
                        return (
                          <MenuItem value={idx + 1} key={idx}>
                            {idx + 1}
                          </MenuItem>
                        );
                      })}
                    </Select>
                    <Typography>月</Typography>
                  </Stack>
                );
              }
              return <></>;
            })}
        </>
      );

    case "checkbox":
      return (
        <>
          <Box my={"5px"} ml={"20px"}>
            <Typography fontWeight={700}>
              {field.label || ""}
              {field.required && (
                <Typography component="label" {...colorRequired}>
                  *
                </Typography>
              )}
            </Typography>
            {field.options.map((option: any, idx: number) => {
              return (
                <FormControlLabel
                  key={idx}
                  control={
                    <Checkbox
                      checked={
                        props.answer && props.answer?.children_answers && props.answer?.children_answers[field.field_id] && props.answer?.children_answers[field.field_id]?.value
                          ? props.answer?.children_answers[field.field_id]?.value.includes(option)
                          : false
                      }
                      onChange={(event) => handleCheckboxChange(event, field.field_id)}
                      value={option}
                      disabled={disable}
                    />
                  }
                  label={option}
                  sx={{
                    "& .MuiSvgIcon-root": { fontSize: "18px" },
                    "& .MuiTypography-root": {
                      fontSize: "14px",
                      wordBreak: "break-word",
                    },
                    mr: "10px",
                    width: "33%",
                  }}
                />
              );
            })}
          </Box>
          {field.dependent_fields && field.dependent_fields[0].type === "checkbox" && (
            <Box my={"5px"} ml={"20px"}>
              <Typography fontWeight={700}>{field.dependent_fields[0].label || ""}</Typography>
              {field.dependent_fields[0].options.map((option: any, idx: number) => {
                return (
                  <FormControlLabel
                    key={idx}
                    control={
                      <Checkbox
                        checked={
                          props.answer && props.answer?.children_answers && props.answer?.children_answers[field.field_id] && props.answer?.children_answers[field.field_id]?.dependent_answers
                            ? props.answer?.children_answers[field.field_id]?.dependent_answers.includes(option)
                            : false
                        }
                        onChange={(event) => handleCheckboxDFChange(event, field.field_id)}
                        value={option}
                        disabled={disable}
                      />
                    }
                    label={option}
                    sx={{
                      "& .MuiSvgIcon-root": { fontSize: "18px" },
                      "& .MuiTypography-root": {
                        fontSize: "14px",
                        wordBreak: "break-word",
                      },
                      mr: "10px",
                      width: "33%",
                    }}
                  />
                );
              })}
            </Box>
          )}

          {field.dependent_fields && field.dependent_fields[0].type === "text" && (
            <Box my={"5px"} ml={"20px"}>
              {props.answer?.children_answers &&
                props.answer?.children_answers[field.field_id] &&
                Array.isArray(props.answer?.children_answers[field.field_id].value) &&
                props.answer?.children_answers[field.field_id].value.map((val: any, index: number) => {
                  return (
                    <>
                      <Stack ml={"20px"}>
                        <Typography>{val}について</Typography>
                      </Stack>
                      <Stack key={index} direction="row" spacing={"8px"} justifyContent={"flex-start"} alignItems={"center"} width={"100%"} my={"8px"} ml={"20px"}>
                        <Typography width={"100px"}>{field.dependent_fields && field.dependent_fields[0].label}</Typography>
                        <OutlinedInput
                          placeholder={""}
                          sx={inputStyle}
                          inputProps={{
                            sx: {
                              backgroundColor: "primary.light",
                            },
                          }}
                          disabled={disable}
                          name={val}
                          value={
                            props.answer?.children_answers &&
                            props.answer?.children_answers[field.field_id] &&
                            props.answer?.children_answers[field.field_id].dependent_answers &&
                            props.answer?.children_answers[field.field_id].dependent_answers.length > 0 &&
                            props.answer?.children_answers[field.field_id].dependent_answers[0][val] !== undefined
                              ? props.answer?.children_answers[field.field_id].dependent_answers[0][val]
                              : ""
                          }
                          onChange={(event) => handleInputForCheckboxChange(event)}
                        />
                      </Stack>
                    </>
                  );
                })}
            </Box>
          )}
        </>
      );
    default:
      return <Box my={"5px"}></Box>;
  }
};

export default GenerateFieldChild;
